/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr sehen`
};

const en_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `See more`
};

const es_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `Más información`
};

const fr_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `Voir plus`
};

const it_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `Per saperne di più`
};

const nl_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `Meer zien`
};

const pt_nudge_card_seemore = /** @type {(inputs: {}) => string} */ () => {
	return `Ver mais`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nudge_card_seemore = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nudge_card_seemore(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("nudge_card_seemore", locale)
	if (locale === "de") return de_nudge_card_seemore(inputs)
	if (locale === "en") return en_nudge_card_seemore(inputs)
	if (locale === "es") return es_nudge_card_seemore(inputs)
	if (locale === "fr") return fr_nudge_card_seemore(inputs)
	if (locale === "it") return it_nudge_card_seemore(inputs)
	if (locale === "nl") return nl_nudge_card_seemore(inputs)
	return pt_nudge_card_seemore(inputs)
};